import { jsx as e } from "react/jsx-runtime";

import { memo as t } from "react";

import { getTabId as o, getTabPanelId as r } from "../utils/index.js";

const a = t((({selected: t, value: a, onChange: n, onFocus: i, label: c, onClick: l, idPrefix: s, ...u}) => e("button", {
    ...u,
    type: "button",
    role: "tab",
    onClick: e => {
        l?.(e), 
        /*
                  Safari does not focus some element on click
                  https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#clicking_and_focus
              */
        e.currentTarget.focus();
    },
    onFocus: e => {
        i?.(e), n(a);
    },
    id: o(s, a),
    "aria-selected": t ? "true" : "false",
    "aria-controls": r(s),
    tabIndex: t ? 0 : -1,
    children: c
})));

export { a as default };
//# sourceMappingURL=index.js.map
